import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  List,
  Box,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
} from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useExperiences } from "../context/ExperiencesContext";
import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";
import Experience from "../components/dashboard/Experience";
import { usePageMetadata } from "../context/PageMetadataContext";
import CreateExperienceDialog from "../components/experiences/CreateExperienceDialog";
import { isEducatorRole } from "../utility/accountRoles";
import { AppButton, Panel } from "../components/ui";

import "./Experiences.scss";

const Experiences = () => {
  const { experiences } = useExperiences();
  const { roleName } = useAuth();
  const { setTitle, setShowTitleInHeader } = usePageMetadata();
  const [sortField, setSortField] = useState("createdAt"); // default sort by date
  const [sortOrder, setSortOrder] = useState("desc"); // newest first

  // State for dialog open/close
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setShowTitleInHeader(true);
    setTitle("Experiences");
  }, [setShowTitleInHeader, setTitle]);

  if (isEducatorRole(roleName)) {
    return <Navigate to="/" replace />;
  }

  return (
    <Container maxWidth="lg" className="experiencesPage">
      <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: 2 }}>
        {/* {DefaultExperiences.map((experience, index) => (
          <ExperienceCard onClick={() => console.log("clicked")} key={experience.id} experience={DefaultExperiences[index]} />
        ))} */}
      </Box>

      <Box mt={4} className="experiencesLaunchRow">
        <AppButton onClick={() => setIsDialogOpen(true)}>
          Launch New Experience
        </AppButton>
      </Box>

      <Box my={4} className="experiencesContent">
        <Box
          className="experiencesHeaderRow"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={1.5}
        >
          <Typography variant="h4" gutterBottom sx={{ mb: 0 }}>
            Experiences
          </Typography>

          {/* Tight Sort by controls */}
          <Stack
            className="experiencesSortControls"
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{ "& .MuiFormControl-root": { m: 0 } }}
          >
            <FormControl size="small" variant="outlined">
              <InputLabel id="sortby-label">Sort</InputLabel>
              <Select
                labelId="sortby-label"
                label="Sort"
                value={sortField}
                onChange={(e) => setSortField(e.target.value)}
                sx={{ minWidth: 160 }}
              >
                <MenuItem value="name">Name</MenuItem>
                <MenuItem value="createdAt">Last Updated</MenuItem>
              </Select>
            </FormControl>

            <Tooltip title={sortOrder === "asc" ? "Ascending" : "Descending"}>
              <IconButton
                size="small"
                onClick={() => setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))}
                sx={{ borderRadius: 1, p: 0.5 }}
              >
                {sortOrder === "asc" ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />}
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>

        {/* Render the experiences as a vertical list */}
        <List className="experiencesList app-row-list">
          {experiences
            ?.slice()
            .sort((a, b) => {
              if (sortField === "name") {
                const an = (a.metadata?.name || "").toLowerCase();
                const bn = (b.metadata?.name || "").toLowerCase();
                const cmp = an.localeCompare(bn);
                return sortOrder === "asc" ? cmp : -cmp;
              } else if (sortField === "createdAt") {
                const ad = new Date(a.metadata?.dateCreated || 0).getTime();
                const bd = new Date(b.metadata?.dateCreated || 0).getTime();
                const cmp = ad - bd;
                return sortOrder === "asc" ? cmp : -cmp;
              }
              return 0;
            })
            .map((experience) => (
              <Panel
                as="li"
                key={experience.experienceId}
                className="experienceRow"
                hoverable
              >
                <Experience experience={experience} enableThumbnailUpload />
              </Panel>
            ))}
        </List>
      </Box>

      <CreateExperienceDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        title="Launch New Experience"
      />
    </Container>
  );
};

export default Experiences;
